const limitValueInRange = (value, [minValue, maxValue]) => {
  if (value < minValue) {
    return minValue;
  } else if (maxValue < value) {
    return maxValue;
  } else {
    return value;
  }
};

export default limitValueInRange;
